const INTERESTS = [
  "TECHNOLOGY", "PHILOSOPHY", "SOCIETY", "PSYCHOLOGY", "HISTORY", "POLITICS",
  "CULTURE", "BLACK IDENTITY", "ECONOMICS", "EDUCATION", "MEDIA", "CREATIVITY",
  "CONSCIOUSNESS", "HUMAN BEHAVIOR", "GENERATIONAL CHANGE", "THE FUTURE",
];

export const Marquee = () => {
  const row = INTERESTS.map((i) => `${i}  ·  `).join("");
  return (
    <div className="border-y border-blue-100/10 py-5 overflow-hidden select-none" data-testid="interests-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((n) => (
          <span key={n} className="font-meta text-xs sm:text-sm tracking-[0.35em] text-blue-200/50 pr-2">
            {row}
          </span>
        ))}
      </div>
    </div>
  );
};
